class utils {
    constructor() {
        this.loading = true
        this.loaded = false
        this.spiner = false
        this.processing = false
        this.onload = false
        this.cookies = true
        this.notificationBox = []
        this.hoverOnNotifications = true
        this.updatingScroll = 0

        this.filters = {
            getHashtageOfText: (text) => {

                let loop = (hashText) => {
                    let position = hashText.search(" #");
                    if (position != -1) {

                        let hashtag = '';
                        for (let i = position + 2; hashText.length > i; i++) {

                            if (hashText.charAt(i) == ' ') break;
                            hashtag += hashText.charAt(i);
                        }
                        if (hashtag.length < 0) return hashText
                        return hashText.replace('#' + hashtag, "<a href='#/hashtag/" + hashtag + "'>" + hashtag + "</a>")
                    } else {
                        return hashText
                    }
                }

                text = loop(text);

                let position = text.search(" #");

                if (position != -1) {
                    text = loop(text);
                }

                return text
            },

            validateEmail: (mail) => {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return true
                }
                return false
            },

            password: (password) => {
                const has_minimum_lenth = password.length > 8;
                const has_number = /\d/.test(password);
                const has_lowercsae = /[a-z]/.test(password);
                const has_uppercase = /[A-Z]/.test(password);
                const has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);

                return {
                    has_minimum_lenth: has_minimum_lenth,
                    has_number: has_number,
                    has_lowercsae: has_lowercsae,
                    has_uppercase: has_uppercase,
                    has_special: has_special,
                };
            },

            username: (name) => {
                const has_minimum_lenth = name.length > 3;
                const only_letters = /^[a-zA-Z0-9@.-]+$/.test(name);
                let is_mail = true

                if (name.includes('@')) {
                    is_mail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(name)
                }

                return {
                    has_minimum_lenth: has_minimum_lenth,
                    only_letters: only_letters,
                    is_mail: is_mail
                };
            },

            name: (name) => {
                const has_minimum_lenth = name.length > 3;
                const only_letters = /^[a-zA-Z ]+$/.test(name);

                return {
                    has_minimum_lenth: has_minimum_lenth,
                    only_letters: only_letters
                };
            },

            stringLimit(val, limit) {
                if (val.length < limit) return val
                return val.substring(0, limit) + '...'
            },

            numberFormat(num) {
                if (Math.abs(num) > 999 && Math.abs(num) < 999950) {
                    num = Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'K'
                } else if (Math.abs(num) > 999949) {
                    num = Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1)) + 'M'
                }
                return num
            },

            hexToRgbA(hex) {
                var c;
                if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                    c = hex.substring(1).split('');
                    if (c.length == 3) {
                        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c = '0x' + c.join('');
                    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)';
                }
                throw new Error('Bad Hex');
            },

            hexToRgb(hex) {
                var c;
                if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                    c = hex.substring(1).split('');
                    if (c.length == 3) {
                        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c = '0x' + c.join('');
                    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
                }
                throw new Error('Bad Hex');
            }

        }

        this.use = {

            browserused: () => {
                let browser = "Unknown";
                // Get the user-agent string
                let userAgentString = navigator.userAgent;

                // Detect Chrome
                let chromeAgent = userAgentString.indexOf("Chrome") > -1;

                // Detect Internet Explorer
                let IExplorerAgent =
                    userAgentString.indexOf("MSIE") > -1 ||
                    userAgentString.indexOf("rv:") > -1;

                // Detect Firefox
                let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

                // Detect Safari
                let safariAgent = userAgentString.indexOf("Safari") > -1;

                // Discard Safari since it also matches Chrome
                if (chromeAgent && safariAgent) safariAgent = false;

                // Detect Opera
                let operaAgent = userAgentString.indexOf("OP") > -1;

                // Discard Chrome since it also matches Opera
                if (chromeAgent && operaAgent) chromeAgent = false;

                if (safariAgent) {
                    browser = "safari";
                } else if (chromeAgent) {
                    browser = "chrome";
                } else if (IExplorerAgent) {
                    browser = "IExplorer";
                } else if (operaAgent) {
                    browser = "opera";
                } else if (firefoxAgent) {
                    browser = "firefox";
                }

                return browser;
            },

            osused: () => {
                let os = "Unknown";
                if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
                    os = "Windows 10";
                if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
                    os = "Windows 8.1";
                if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
                    os = "Windows 8";
                if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
                    os = "Windows 7";
                if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
                    os = "Windows Vista";
                if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
                    os = "Windows XP";
                if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
                    os = "Windows 2000";
                if (window.navigator.userAgent.indexOf("Mac") != -1) os = "Mac/iOS";
                if (window.navigator.userAgent.indexOf("X11") != -1) os = "UNIX";
                if (window.navigator.userAgent.indexOf("Linux") != -1) os = "Linux";

                return os;
            },

            deviceused: () => {
                let devive = "Unknown";
                var isMobile = window.orientation > -1;

                if (isMobile && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    devive = "smartphone";
                } else {
                    devive = "desktop";
                }

                return devive;
            },

            getLanguage: () => {
                let language = "Unknown";


                if (window.navigator.language) {
                    language = window.navigator.language;
                }

                return language;
            },
        }

        document.body.onscroll = (e) => {
            this.updatingScroll = document.body.scrollTop || document.documentElement.scrollTop;
        };
    }

    switchLanguage(val) {
        if (localStorage.language != val) {
            localStorage.language = val
            location.reload();
        }
    }



    // HOW TO SENDING MESSAGE FOR POPUP 
    // $store.state.utils.setNewNotifications({
    //     type: 'info, warning, hint, success',
    //     title: 'Hinweis! (option)',
    //     message: 'your text',
    //     url: 'link (option)' ,
    //   }, 1500)
    removeNotifications(interval) {
        setTimeout(() => {
            if (this.hoverOnNotifications) {
                this.notificationBox.shift()
            } else {
                this.removeNotifications(interval)
            }
        }, interval);
    }

    setNewNotifications(val, interval = 0) {
        this.notificationBox.push(val)
        if (interval > 100) {
            this.removeNotifications(interval)
        }
    }

    switTypeInput() {
        if (document.querySelector("#password").type == "text") {
            document.querySelector("#password").type = "password";
        } else {
            document.querySelector("#password").type = "text";
        }

        if (document.querySelector("#repeatPassword")) {
            if (document.querySelector("#repeatPassword").type == "text") {
                document.querySelector("#repeatPassword").type = "password";
            } else {
                document.querySelector("#repeatPassword").type = "text";
            }
        }

        if (document.querySelector("#currentPassword")) {
            if (document.querySelector("#currentPassword").type == "text") {
                document.querySelector("#currentPassword").type = "password";
            } else {
                document.querySelector("#currentPassword").type = "text";
            }
        }
    }

    calcTotalStorage() {
        let _lsTotal = 0,
            _xLen, _x, etch = {};
        for (_x in localStorage) {
            if (!localStorage.hasOwnProperty(_x)) {
                continue;
            }
            _xLen = ((localStorage[_x].length + _x.length) * 2);
            _lsTotal += _xLen;
            etch[_x.substr(0, 50)] = (_xLen / 1024).toFixed(2) + " KB"
        };
        let totla = (_lsTotal / 1024).toFixed(2) + " KB";

        return {
            ...etch,
            totla: totla,
        }
    }


}
export default utils